import { DObj } from '../models/domain/dobj';

export class DObjsUtil {
    private static instance: DObjsUtil;

    static getInstance() {
        if (!DObjsUtil.instance) {
            DObjsUtil.instance = new DObjsUtil();
        }
        return DObjsUtil.instance;
    }

    /**
    * DObjsUtil is a singleton class, so use DObjsUtil.getInstance() method instead of creating new DObjsUtil().
    */
    private constructor() {

    }

    copy(dObjs: Array<DObj>): Array<DObj> {
        let dObjTmp: Array<DObj> = new Array<DObj>();

        for (let i: number = 0; i < dObjs.length; i++) {
            let dObj: DObj = dObjs[i] as DObj;
            dObjTmp.push(dObj.copy())
        }
        return dObjTmp;
    }

    copyFrom(dObjs: Array<DObj>, dObjsTmp: Array<DObj>): void {
        let dObjsMap: Map<string, DObj> = new Map();

        let dObjsLength: number = dObjs.length;
        for (let i: number = 0; i < dObjsLength; i++) {
            dObjsMap.set(dObjs[i].dObj_Id + '-' + dObjs[i].nm, dObjs[i]);
        }

        dObjs.splice(0, dObjs.length);

        let dObjsTmpLength: number = dObjsTmp.length;
        for (let i: number = 0; i < dObjsTmpLength; i++) {
            let dObjTmp: DObj = dObjsTmp[i] as DObj;
            let dObj: DObj = dObjsMap.get(dObjTmp.dObj_Id + '-' + dObjTmp.nm);
            if (dObj) {
                dObj.copyFrom(dObjTmp);
            } else {
                dObj = DObj.parse(dObjTmp);
            }

            dObjs.push(dObj);
        }
    }

    toString(dObjs: Array<DObj>): string {
        let str: string = '';

        str += 'dObjs length: ' + dObjs.length + ' ';
        for (let i: number = 0; i < dObjs.length; i++) {
            str += dObjs[i].toString();
        }

        return str;
    }

}